import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import Swal from 'sweetalert2';
import { getTiposMembresia } from '../../../services/tipo-membresias/tipoMembresiaService';
import { lenguage, optionsTable, tableIcons } from "../../structure/config-datatable";
import { TipoMembresiasEditModal } from './edit-modal/TipoMembresiasEditModal';

export const DatatableTipoMembresias = () => {
    const [state, setState] = useState([]);
    const [modalEditar, setModalEditar] = useState(false);
    const [edit, setEdit] = useState({});
    const [loading, setLoading] = useState(true);

    // Cargar tipos de membresía
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const data = await getTiposMembresia();
                setState(data);
            } catch (error) {
                console.log('Error fetching tipos de membresía:', error);
                Swal.fire('Error', 'Error al cargar tipos de membresía', 'error');
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    // Acciones de la tabla
    const acciones = [
        {
            icon: () => <tableIcons.Edit style={{ color: "#FFC007" }} />,
            tooltip: 'Editar',
            onClick: (e, rowData) => {
                setEdit({
                    id: rowData.id,
                    membresia: rowData.membresia,
                    descripcion: rowData.descripcion || '',
                    url_compra: rowData.url_compra || '',
                    max_auxiliares: rowData.max_auxiliares,
                    max_clientes: rowData.max_clientes
                });
                setModalEditar(true);
            }
        }
    ];

    // Columnas de la tabla
    const columnas = [
        {
            title: "ID",
            field: "id",
            width: '6%'
        },
        {
            title: "Nombre del Plan",
            field: "membresia",
            width: '18%'
        },
        {
            title: "Descripción",
            field: "descripcion",
            width: '22%'
        },
        {
            title: "URL Compra",
            field: "url_compra",
            width: '20%'
        },
        {
            title: "Máx. Auxiliares",
            field: "max_auxiliares",
            type: "numeric",
            width: '17%'
        },
        {
            title: "Máx. Clientes",
            field: "max_clientes",
            type: "numeric",
            width: '17%'
        }
    ];

    // Recargar tabla después de editar
    const handleReload = async () => {
        const data = await getTiposMembresia();
        setState(data);
    };

    return (
        <>
            <div className="card-body">
                {loading ? (
                    <p>Cargando...</p>
                ) : (
                    <>
                        <MaterialTable
                            icons={tableIcons}
                            columns={columnas}
                            data={state}
                            title={""}
                            options={optionsTable}
                            localization={lenguage}
                            actions={acciones}
                        />
                        <TipoMembresiasEditModal 
                            setModalEditar={setModalEditar}
                            modalEditar={modalEditar}
                            editar={edit}
                            onReload={handleReload}
                        />
                    </>
                )}
            </div>
        </>
    );
};
